import * as React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import Autocomplete from '@mui/material/Autocomplete';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import PendingIcon from '@mui/icons-material/Pending';
import TransgenderIcon from '@mui/icons-material/Transgender';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditNoteIcon from '@mui/icons-material/EditNote';
import TheatersIcon from '@mui/icons-material/Theaters';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import HelpIcon from '@mui/icons-material/Help';

import LocationCityIcon from '@mui/icons-material/LocationCity';
import Diversity3Icon from '@mui/icons-material/Diversity3';

import FormGroup from '@mui/material/RadioGroup';
import Checkbox from '@mui/material/Radio';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';

import Onboarder, {
  Steps,
  Structure,
  useGlobalState,
} from '@guestbell/onboarder';
import { CustomList } from './CustomList';
import FancyStepContainer, {
  ExtraStepProps,
} from './stepContainer/FancyStepContainer';

import axios from 'axios';
import { useNavigate } from 'react-router';

export interface FancyProps {
  debug?: boolean;
}

type OnboarderState = {
  skillsStep: never;
  locationsStep: never;
  filmsStep: never;
  genderStep: never;
  ethnicityStep: never;
  externalAccountsStep: never;
};

const onboardingData = {
  skills: '',
  experience: 0,
  locations: [],
  filmsExperience: '',
  gender: '',
  ethnicity: '',
  externalAccounts: {},
};

function handleSkills(event) {
  const skill = event.target.value;
  if (skill) onboardingData['skills'] = skill;
}

function handleExperience(event) {
  const years = event.target.value;
  onboardingData['experience'] = years;
}

function handleLocations(event, locations) {
  onboardingData['locations'] = locations;
}

function handleFilmsExperience(event) {
  const film = event.target.value;
  onboardingData['filmsExperience'] = film;

  const filmOptions = document.getElementsByClassName('film-checked');
  for (var i = 0; i < filmOptions.length; i++) {
    const opt = filmOptions[i].id;
    filmOptions[i].classList.remove('checked-' + opt);
    filmOptions[i].classList.remove('film-checked');
  }

  const filmLabel = document.getElementById(film + '-ckb');
  if (filmLabel) {
    filmLabel.classList.add('film-checked');
    filmLabel.classList.add('checked-' + film + '-ckb');
  }
}

function handleGender(event) {
  const selection = event.target.value;
  onboardingData['gender'] = selection;

  const genders = document.getElementsByClassName('gender-checked');
  for (var i = 0; i < genders.length; i++) {
    const gender = genders[i].id;
    genders[i].classList.remove('checked-' + gender);
    genders[i].classList.remove('gender-checked');
  }

  const genderLabel = document.getElementById(selection + '-ckb');
  if (genderLabel) {
    genderLabel.classList.add('gender-checked');
    genderLabel.classList.add('checked-' + selection + '-ckb');
  }
}

function handleEthnicity(event) {
  onboardingData['ethnicity'] = event.target.value as string;
}

function handleExternalAccounts(event) {
  const acct = event.target.value;
  const acctEnabled =
    !onboardingData['externalAccounts'][acct] ||
    !onboardingData['externalAccounts'][acct]['state'];

  if (acct === 'none') {
    onboardingData['externalAccounts'] = {};
    const allExt = document.getElementsByClassName('external-checkbox');
    for (var i = 0; i < allExt.length; i++) {
      const extAcct = allExt[i] as HTMLInputElement;
      extAcct.classList.remove('checked-' + extAcct.id);
      const extAcctVal = extAcct.id.replace('-ckb', '');
      const acctInput = document.getElementById(
        extAcctVal + '-inp'
      ) as HTMLInputElement;
      const acctInputLabel = document.getElementById(extAcctVal + '-label');
      if (acctInput && acctInputLabel) {
        acctInput.classList.remove('show');
        acctInputLabel.classList.remove('show');
        acctInput.value = '';
      }
    }
  } else {
    const acctInput = document.getElementById(
      acct + '-inp'
    ) as HTMLInputElement;
    const acctInputLabel = document.getElementById(acct + '-label');
    if (acctInput && acctInputLabel) {
      if (acctEnabled) {
        acctInput.classList.add('show');
        acctInputLabel.classList.add('show');
      } else {
        acctInput.classList.remove('show');
        acctInputLabel.classList.remove('show');
        acctInput.value = '';
      }
    }
  }

  onboardingData['externalAccounts'][acct] = { state: acctEnabled };
  const acctLabel = document.getElementById(acct + '-ckb');
  if (acctLabel) {
    if (acctEnabled) acctLabel.classList.add('checked-' + acct + '-ckb');
    else acctLabel.classList.remove('checked-' + acct + '-ckb');
  }
}

function saveExternalAccountsLink(event) {
  const extAcctVal = event.target.id.replace('-inp', '');
  onboardingData['externalAccounts'][extAcctVal]['value'] = event.target.value;
}

function formatData(data) {
  var formattedData = {};
  formattedData['gender'] = data['gender'];
  formattedData['experience_level'] = data['skills'];
  formattedData['years_of_experience'] = parseInt(data['experience']);
  formattedData['experience_on_films'] = data['filmsExperience'];

  if (!data['externalAccounts']['none']) {
    if (
      data['externalAccounts']['imdb'] &&
      data['externalAccounts']['imdb']['state']
    )
      formattedData['imdb_url'] = data['externalAccounts']['imdb']['value'];
    if (
      data['externalAccounts']['facebook'] &&
      data['externalAccounts']['facebook']['state']
    )
      formattedData['facebook_url'] =
        data['externalAccounts']['facebook']['value'];
    if (
      data['externalAccounts']['instagram'] &&
      data['externalAccounts']['instagram']['state']
    )
      formattedData['instagram_url'] =
        data['externalAccounts']['instagram']['value'];
    if (
      data['externalAccounts']['linkedin'] &&
      data['externalAccounts']['linkedin']['state']
    )
      formattedData['linkedin_url'] =
        data['externalAccounts']['linkedin']['value'];
  }

  return formattedData;
}

function submitData(event) {
  const urlParts = window.location.pathname.split('/');
  const userId = urlParts[urlParts.length - 1];

  event.preventDefault();
  axios
    .patch(
      'http://100.112.4.142:9000/user/' + userId,
      formatData(onboardingData)
    )
    .then(
      (response) => {
        goToAdminDashboard();
      },
      (error) => {
        console.log('errors');
      }
    );
}

function goToAdminDashboard() {
  window.location.href = '/admin/dashboard';
}

const steps: Steps<OnboarderState, ExtraStepProps> = {
  skillsStep: {
    Component: ({ goToNextStep }) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
        width="100%"
        sx={{ backgroundImage: 'url(/onboarding_1_bg.jpg)' }}
      >
        <Box className="onboardingSection">
          <Typography variant="h3" marginBottom={2} className="centered">
            👋Welcome!
          </Typography>
          <Typography variant="subtitle1" className="centered">
            What do you do? Tell us about your productions skills.
          </Typography>

          <select
            name="skills"
            className="skills-dropdown"
            onChange={handleSkills}
          >
            <option value="">Please Select</option>
            <option value="director">Director</option>
          </select>

          <hr />

          <Typography
            variant="subtitle2"
            sx={{ marginTop: '10px', marginBottom: '20px' }}
            className="centered"
          >
            How many years of experience do you have?
          </Typography>

          <Slider
            aria-label="Always visible"
            defaultValue={0}
            step={1}
            valueLabelDisplay="on"
            onChange={handleExperience}
            sx={{ marginTop: '15px' }}
          />

          <div className="onboardingActions">
            <Button
              sx={{ marginTop: 10, '&:hover': { backgroundColor: '#33bfff' } }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Continue
            </Button>
            <Button
              sx={{
                marginTop: 10,
                backgroundColor: 'white',
                color: '#1976d2',
                '&:hover': { backgroundColor: 'transparent', color: '#33bfff' },
              }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Skip &gt;
            </Button>
          </div>
        </Box>
      </Box>
    ),
    title: 'Skills',
    subtitle: 'What do you do?',
    hideUi: true,
  },
  locationsStep: {
    Component: ({ goToNextStep }) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
        width="100%"
        sx={{ backgroundImage: 'url(/onboarding_2_bg.jpg)' }}
      >
        <Box className="onboardingSection">
          {/*<div className="sectionIcon"><LocationCityIcon sx={{color:"#33bfff",fontSize:"100px"}} /></div>*/}

          <Typography variant="subtitle1" className="centered">
            What are your preferred locations?
          </Typography>

          <Autocomplete
            multiple
            disablePortal
            id="locations"
            options={['Montreal, Canada', 'Miami, Florida', 'New Orleans, LA']}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Enter Location(s)"
                placeholder="Add Location"
              />
            )}
            sx={{ marginTop: '15px' }}
            onChange={handleLocations}
          />

          <div className="onboardingActions">
            <Button
              sx={{ marginTop: 10, '&:hover': { backgroundColor: '#33bfff' } }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Continue
            </Button>
            <Button
              sx={{
                marginTop: 10,
                backgroundColor: 'white',
                color: '#1976d2',
                '&:hover': { backgroundColor: 'transparent', color: '#33bfff' },
              }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Skip &gt;
            </Button>
          </div>
        </Box>
      </Box>
    ),
    title: 'Locatons',
    subtitle: 'Where do you want to work?',
    hideUi: true,
  },
  filmsStep: {
    Component: ({ goToNextStep }) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
        width="100%"
        sx={{ backgroundImage: 'url(/onboarding_7_bg.jpg)' }}
      >
        <Box className="onboardingSection">
          <Typography variant="subtitle1" className="centered">
            Do you have experience with:
          </Typography>

          <FormGroup onChange={handleFilmsExperience} className="gridBlock3">
            <FormControlLabel
              id="scripted-ckb"
              className="films-checkbox"
              value="scripted"
              control={
                <Checkbox
                  icon={
                    <EditNoteIcon
                      sx={{ color: '#33bfff', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <EditNoteIcon
                      sx={{ color: '#33bfff', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="Scripted Films"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="unscripted-ckb"
              className="films-checkbox"
              value="unscripted"
              control={
                <Checkbox
                  icon={
                    <TheatersIcon
                      sx={{ color: '#33bfff', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <TheatersIcon
                      sx={{ color: '#34ebc9', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="Unscripted Films"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="feature-ckb"
              className="films-checkbox"
              value="feature"
              control={
                <Checkbox
                  icon={
                    <GroupWorkIcon
                      sx={{ color: '#33bfff', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <GroupWorkIcon
                      sx={{ color: '#e234eb', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="Feature Films"
              labelPlacement="bottom"
            />
          </FormGroup>

          <div className="onboardingActions">
            <Button
              sx={{ marginTop: 10, '&:hover': { backgroundColor: '#33bfff' } }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Continue
            </Button>
            <Button
              sx={{
                marginTop: 10,
                backgroundColor: 'white',
                color: '#1976d2',
                '&:hover': { backgroundColor: 'transparent', color: '#33bfff' },
              }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Skip &gt;
            </Button>
          </div>
        </Box>
      </Box>
    ),
    title: 'Films',
    subtitle: 'Do you have experience with films?',
    hideUi: true,
  },
  genderStep: {
    Component: ({ goToNextStep }) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
        width="100%"
        sx={{ backgroundImage: 'url(/onboarding_4_bg.jpg)' }}
      >
        <Box className="onboardingSection">
          <Typography variant="subtitle1" className="centered">
            When it comes to gender, how do you identify?
          </Typography>

          <FormGroup onChange={handleGender} className="gridBlock4">
            <FormControlLabel
              id="man-ckb"
              className="gender-checkbox"
              value="man"
              control={
                <Checkbox
                  icon={
                    <ManIcon sx={{ color: '#33bfff', fontSize: '100px' }} />
                  }
                  checkedIcon={
                    <ManIcon sx={{ color: '#33bfff', fontSize: '100px' }} />
                  }
                />
              }
              label="Man"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="woman-ckb"
              className="gender-checkbox"
              value="woman"
              control={
                <Checkbox
                  icon={
                    <WomanIcon sx={{ color: '#f44336', fontSize: '100px' }} />
                  }
                  checkedIcon={
                    <WomanIcon sx={{ color: '#f44336', fontSize: '100px' }} />
                  }
                />
              }
              label="Woman"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="non-binary-ckb"
              className="gender-checkbox"
              value="non-binary"
              control={
                <Checkbox
                  icon={
                    <TransgenderIcon
                      sx={{ color: '#ff9800', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <TransgenderIcon
                      sx={{ color: '#ff9800', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="Non-binary"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="no-answer-ckb"
              className="gender-checkbox"
              value="no-answer"
              control={
                <Checkbox
                  icon={
                    <PendingIcon sx={{ color: '#af52bf', fontSize: '100px' }} />
                  }
                  checkedIcon={
                    <PendingIcon sx={{ color: '#af52bf', fontSize: '100px' }} />
                  }
                />
              }
              label="I'd rather not say"
              labelPlacement="bottom"
            />
          </FormGroup>

          <div className="onboardingActions">
            <Button
              sx={{ marginTop: 10, '&:hover': { backgroundColor: '#33bfff' } }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Continue
            </Button>
            <Button
              sx={{
                marginTop: 10,
                backgroundColor: 'white',
                color: '#1976d2',
                '&:hover': { backgroundColor: 'transparent', color: '#33bfff' },
              }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Skip &gt;
            </Button>
          </div>
        </Box>
      </Box>
    ),
    title: 'Gender',
    subtitle: 'How do you identify?',
    hideUi: true,
  },
  ethnicityStep: {
    Component: ({ goToNextStep }) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
        width="100%"
        sx={{ backgroundImage: 'url(/onboarding_5_bg.jpg)' }}
      >
        <Box className="onboardingSection">
          <Typography variant="subtitle1" className="centered">
            What's your ethnicity?
          </Typography>

          <FormControl fullWidth>
            <NativeSelect
              inputProps={{
                name: 'ethnicity',
                id: 'ethnicity-select',
              }}
              onChange={handleEthnicity}
            >
              <option value="">Please Select</option>
              <option value="American Indian/Alaska Native">
                American Indian/Alaska Native
              </option>
              <option value="Asian">Asian</option>Native America
              <option value="Black or African American">
                Black or African American
              </option>
              <option value="Native Hawaiian or other Pacific Islander">
                Native Hawaiian or other Pacific Islander
              </option>
              <option value="White">White</option>
            </NativeSelect>
          </FormControl>

          <div className="onboardingActions">
            <Button
              sx={{ marginTop: 10, '&:hover': { backgroundColor: '#33bfff' } }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Continue
            </Button>
            <Button
              sx={{
                marginTop: 10,
                backgroundColor: 'white',
                color: '#1976d2',
                '&:hover': { backgroundColor: 'transparent', color: '#33bfff' },
              }}
              variant="contained"
              onClick={goToNextStep}
              disableElevation={true}
            >
              Skip &gt;
            </Button>
          </div>
        </Box>
      </Box>
    ),
    title: 'Ethnicity',
    subtitle: "What's your ethnicity?",
    hideUi: true,
  },
  externalAccountsStep: {
    Component: ({ goToNextStep }) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100%"
        width="100%"
        sx={{ backgroundImage: 'url(/onboarding_6_bg.jpg)' }}
      >
        <Box className="onboardingSection" sx={{ width: '70% !important' }}>
          <Typography variant="h5" className="centered">
            Do you have:
          </Typography>
          <Typography variant="subtitle1" className="centered">
            Select all that apply
          </Typography>

          <FormGroup onClick={handleExternalAccounts} className="gridBlock5">
            <FormControlLabel
              id="imdb-ckb"
              className="external-checkbox"
              value="imdb"
              control={
                <Checkbox
                  icon={
                    <VideoLibraryIcon
                      sx={{ color: '#f3ce13', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <VideoLibraryIcon
                      sx={{ color: '#f3ce13', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="IMDb"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="linkedin-ckb"
              className="external-checkbox"
              value="linkedin"
              control={
                <Checkbox
                  icon={
                    <LinkedInIcon
                      sx={{ color: '#0A66C2', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <LinkedInIcon
                      sx={{ color: '#0A66C2', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="LinkedIn"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="facebook-ckb"
              className="external-checkbox"
              value="facebook"
              control={
                <Checkbox
                  icon={
                    <FacebookIcon
                      sx={{ color: '#3b5998', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <FacebookIcon
                      sx={{ color: '#3b5998', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="Facebook"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="instagram-ckb"
              className="external-checkbox"
              value="instagram"
              control={
                <Checkbox
                  icon={
                    <InstagramIcon
                      sx={{ color: '#fa7e1e', fontSize: '100px' }}
                    />
                  }
                  checkedIcon={
                    <InstagramIcon
                      sx={{ color: '#fa7e1e', fontSize: '100px' }}
                    />
                  }
                />
              }
              label="Instagram"
              labelPlacement="bottom"
            />
            <FormControlLabel
              id="none-ckb"
              className="external-checkbox"
              value="none"
              control={
                <Checkbox
                  icon={
                    <HelpIcon sx={{ color: '#33bfff', fontSize: '100px' }} />
                  }
                  checkedIcon={
                    <HelpIcon sx={{ color: '#33bfff', fontSize: '100px' }} />
                  }
                />
              }
              label="None of these"
              labelPlacement="bottom"
            />
          </FormGroup>

          <div className="inputsSection">
            <label id="imdb-label" htmlFor="imdb-inp">
              IMDb Link
            </label>
            <input
              id="imdb-inp"
              className="external-account-link"
              type="text"
              onChange={saveExternalAccountsLink}
              placeholder="Enter your IMDb profile link"
            />

            <label id="linkedin-label" htmlFor="linkedin-inp">
              LinkedIn Link
            </label>
            <input
              id="linkedin-inp"
              className="external-account-link"
              type="text"
              onChange={saveExternalAccountsLink}
              placeholder="Enter your LinkedIn profile link"
            />

            <label id="facebook-label" htmlFor="facebook-inp">
              Facebook Link
            </label>
            <input
              id="facebook-inp"
              className="external-account-link"
              type="text"
              onChange={saveExternalAccountsLink}
              placeholder="Enter your Facebook profile link"
            />

            <label id="instagram-label" htmlFor="instagram-inp">
              Instagram Link
            </label>
            <input
              id="instagram-inp"
              className="external-account-link"
              type="text"
              onChange={saveExternalAccountsLink}
              placeholder="Enter your Instagram page link"
            />
          </div>

          <div className="onboardingActions">
            <Button
              sx={{ marginTop: 10, '&:hover': { backgroundColor: '#33bfff' } }}
              variant="contained"
              onClick={submitData}
              disableElevation={true}
            >
              Finish
            </Button>
          </div>
        </Box>
      </Box>
    ),
    title: 'External Accounts',
    subtitle: 'Want to link your external accounts?',
    hideUi: true,
  },
};

const finalSteps: (keyof OnboarderState)[] = ['externalAccountsStep'];

const structure: Structure<OnboarderState> = {
  skillsStep: () => ({ locationsStep: 1 }),
  locationsStep: () => ({ filmsStep: 1 }),
  filmsStep: () => ({ genderStep: 1 }),
  genderStep: () => ({ ethnicityStep: 1 }),
  ethnicityStep: () => ({ externalAccountsStep: 1 }),
};

export const Fancy: React.FC<FancyProps> = ({ debug }) => {
  return (
    <>
      <Onboarder<OnboarderState, ExtraStepProps>
        steps={steps}
        initialStep="skillsStep"
        finalSteps={finalSteps}
        structure={structure}
        StepContainer={FancyStepContainer}
        debug={debug}
      />
    </>
  );
};

export default Fancy;
